module.exports = __webpack_public_path__ + "img/infinity-loop.b6b27214.gif";